// IMPORTS
// Modules
import $ from 'jquery';
// Assets
import './../scss/OHSFilter.scss';


// COMPONENT
export default function OHSFilter (props) {
   // States and Variables
   const inputID = 'ohsfilter-' + Math.floor(Math.random() * 999999);

   // Functions
   const filter = function () {
      $('#' + props.container + ' [data-ohsfilter]').each(function () {
         let string = String($(this).data('ohsfilter'));
         if (/^\d+$/.test(string) === false) {
            string = string.toLowerCase(); //used if filter data is not just numbers
         }
         let term = $('#' + inputID).val().toLowerCase();
         if (string.includes(term)) {
            $(this).show();
         } else {
            $(this).hide();
         }
      });
   }
   const clearFilter = function () {
      $('#' + inputID).val('');
      $('#' + props.container + ' [data-ohsfilter]').each(function () {
         $(this).show();
      });
   }

   // Component
   return (
      <div className='ohsfilter'>
         <input id={inputID} className='ohsinput' type='text' placeholder={props.title} onChange={filter} />
         <button className='ohsbtn' onClick={clearFilter}>Clear</button> 
      </div>
   );
}